import { IconButton, IconName } from '@optimus-web/core';
import { TextKey, DataTestId } from '@mews-commander/enums';
import { UserProfileResult } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { useTableActionsInfo } from '../../hooks/useTableActionsInfo';
import { TooltipWrapper } from '../TooltipWrapper';
import { useOpenEditUserDialog } from './EditUserDialog';

export const EditUserButton = ({ userProfile }: { userProfile: UserProfileResult }) => {
    const { isActionDisabled, isOwnProfile } = useTableActionsInfo(userProfile);
    const handleEdit = useOpenEditUserDialog({ userProfile });

    return (
        <TooltipWrapper
            active={isActionDisabled}
            tooltip={
                <LocalizedText
                    textKey={
                        isOwnProfile
                            ? TextKey.UserManagementCannotEditOwnProfileTooltip
                            : TextKey.UserManagementCannotEditAdminTooltip
                    }
                />
            }
        >
            <IconButton
                variant="tertiary"
                icon={IconName.Edit}
                onClick={handleEdit}
                size="small"
                disabled={isActionDisabled}
                data-test-id={DataTestId.TableActionEdit}
                type="submit"
            />
        </TooltipWrapper>
    );
};
